import React from 'react';

// Types
import { UserRole } from 'Shared/constants/types';
import { Member } from 'Shared/types/Member.type';

type Props = {
  member: Member;
};

const MemberRole = ({ member }: Props) => {
  const normalizedRole = role => {
    if (role === UserRole.admin) return 'Admin';
    if (role === UserRole.fullMember) return 'Individual Contributor';
    if (role === UserRole.manager) return 'Manager';

    return '';
  };

  const role = normalizedRole(member.role);

  return <div>{role}</div>;
};

export default MemberRole;
